<template>
    <Splide
        ref="splide"
        id="cycle-stages"
        class="cursor-grab active:cursor-grabbing"
        :options="options"
    >
        <SplideSlide>
            <slot name="stage1"></slot>
        </SplideSlide>

        <SplideSlide>
            <slot name="stage2"></slot>
        </SplideSlide>

        <SplideSlide>
            <slot name="stage3"></slot>
        </SplideSlide>
    </Splide>
</template>

<script setup lang="ts">
import { inject, onMounted, ref } from "vue";
import type { AppEmitter } from "../../emitter";

const props = withDefaults(
    defineProps<{
        duration?: number;
    }>(),
    {
        duration: 10000,
    },
);

const emitter = inject<AppEmitter>("mitt")!;
const splide = ref<any>(null);
const options = {
    type: "slide",
    arrows: false,
    pagination: false,
    rewind: true,
    autoplay: true,
    interval: props.duration,
};

onMounted(() => emitter.on("nextSlide", () => splide.value.go(">")));
</script>
